import { brl, fmtDateTime, imgUrl, PAY_LABELS, ORIGIN_LABELS, CASH_MOVE_LABELS } from "@/lib/api";

const ESC = "\x1B";
const GS = "\x1D";
const plain = (t) => String(t ?? "").replace(/\u00a0/g, " ").normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^\x20-\x7E\n]/g, "");
const pad3 = (n) => String(n).padStart(3, "0");
const abs = (u) => { const x = imgUrl(u); return x && x.startsWith("/") ? `${window.location.origin}${x}` : x; };
export const LOGO_SIZES = [["p", "Pequeno", 0.35], ["m", "Médio", 0.55], ["g", "Grande", 0.8], ["gg", "Largura total", 1]];
const logoWidth = (pr) => {
  const frac = (LOGO_SIZES.find((s) => s[0] === pr.logo_size) || LOGO_SIZES[1])[2];
  return Math.max(64, Math.floor(((Number(pr.columns) || 42) <= 32 ? 384 : 576) * frac / 8) * 8);
};

function doc(pr) {
  const cols = Number(pr.columns) || 42;
  const out = [ESC + "@"];
  const w = (t) => out.push(`${plain(t)}\n`);
  const d = {
    raw: (c) => { out.push(c); return d; },
    text: (t) => { w(t); return d; },
    center: (t) => { out.push(`${ESC}a\x01`); w(t); out.push(`${ESC}a\x00`); return d; },
    big: (t) => { out.push(`${ESC}a\x01${GS}!\x11`); w(t); out.push(`${GS}!\x00${ESC}a\x00`); return d; },
    lr: (l, r, bold) => {
      const a = plain(l); const b = plain(r);
      if (bold) out.push(`${ESC}E\x01`);
      if (a.length + b.length + 1 > cols) { w(a); w(" ".repeat(Math.max(0, cols - b.length)) + b); } else w(a + " ".repeat(cols - a.length - b.length) + b);
      if (bold) out.push(`${ESC}E\x00`);
      return d;
    },
    hr: () => { w("-".repeat(cols)); return d; },
    logo: (u) => {
      if (u && pr.logo !== false) {
        out.push(`${ESC}a\x01`, { type: "raw", format: "image", flavor: "file", data: abs(u), _width: logoWidth(pr), options: { language: "ESCPOS", dotDensity: "double" } }, `\n${ESC}a\x00`);
      }
      return d;
    },
    cut: () => { out.push("\n\n\n\n"); if (pr.cut !== false) out.push(`${GS}V\x41\x03`); return d; },
    out,
  };
  return d;
}

export function testPage(pr, store, logoUrl) {
  return doc(pr).logo(logoUrl).big("TESTE").center(store).center(`Impressora: ${pr.name}`).center(`${pr.columns} colunas`).hr().lr("Item de exemplo", brl(12.5)).lr("TOTAL", brl(12.5), true).cut().out;
}

export const reprintHead = (pr) => doc(pr).big("2a VIA").center(`Reimpressao - ${fmtDateTime(new Date().toISOString())}`).hr().out;

export function saleReceipt(sale, t, pr) {
  const d = doc(pr).logo(t.settings?.ticket_logo !== false && t.settings?.logo_url).center(t.nome_fantasia);
  if (t.documento) d.center(t.documento);
  d.center(`${fmtDateTime(sale.created_at)} - ${ORIGIN_LABELS[sale.origin] || ""}`).center(`Venda #${sale.number}`).hr();
  sale.items.forEach((i) => { d.lr(`${i.qty}x ${i.name}`, brl(i.total)); if (i.notes) d.text(`  Obs: ${i.notes}`); });
  d.hr();
  [["Desconto", -sale.discount], ["Fidelidade", -sale.loyalty_discount], ["Servico", sale.service_fee], ["Acrescimo", sale.surcharge], ["Entrega / taxas", sale.extra_fee]]
    .forEach(([l, v]) => v && d.lr(l, brl(v)));
  d.lr("TOTAL", brl(sale.total), true);
  sale.payments.forEach((p) => d.lr(PAY_LABELS[p.method] || p.method, brl(p.amount)));
  if (sale.change > 0) d.lr("Troco", brl(sale.change));
  if (sale.customer) d.text(`Cliente: ${sale.customer.name}`);
  if (sale.pickup_number) d.hr().center("SENHA DE RETIRADA").big(pad3(sale.pickup_number));
  d.text(`Operador: ${sale.user_name}`);
  if (sale.receipt_footer) d.center(sale.receipt_footer);
  return d.center("Documento sem valor fiscal").cut().out;
}

export function ticketSlips(sale, t, pr) {
  const d = doc(pr);
  sale.tickets.forEach((k) => {
    d.logo(t.settings?.ticket_logo !== false && t.settings?.logo_url).center(t.nome_fantasia).big(k.product_name).center(`VALE 1 UNIDADE - ${k.seq}/${k.of}`);
    if (sale.pickup_number) d.center(`SENHA ${pad3(sale.pickup_number)}`);
    d.big(k.code).center(`Venda #${sale.number} - ${fmtDateTime(k.created_at)} - ${k.sold_by}`);
    if (sale.receipt_footer) d.center(sale.receipt_footer);
    d.cut();
  });
  return d.out;
}

export function orderSlip(order, title, items, store, pr) {
  const d = doc(pr).center(store).big(`${title} - PEDIDO ${order.number}`).center(order.label);
  if (order.customer) d.big(`Cliente: ${order.customer}`);
  d.center(`${fmtDateTime(order.at)} - ${order.user}`).hr();
  items.forEach((i) => { d.raw(`${GS}!\x01`).text(`${i.qty}x ${i.name}`).raw(`${GS}!\x00`); if (i.notes) d.text(`   Obs: ${i.notes}`); });
  if (order.pickup_number) d.hr().center("SENHA").big(pad3(order.pickup_number));
  return d.cut().out;
}

export function comandaBill(c, t, pr) {
  const d = doc(pr).logo(t.settings?.ticket_logo !== false && t.settings?.logo_url).center(t.nome_fantasia).big(`CONTA - COMANDA ${c.number}`);
  if (c.table_number) d.center(`Mesa ${c.table_number}`);
  if (c.customer_name) d.center(c.customer_name);
  d.center(fmtDateTime(new Date().toISOString())).hr();
  c.items.forEach((i) => d.lr(`${i.qty}x ${i.name}`, brl(i.total)));
  d.hr().lr("Subtotal", brl(c.subtotal));
  [["Desconto", -c.discount], ["Servico", c.service_fee], ["Acrescimo", c.surcharge]].forEach(([l, v]) => v && d.lr(l, brl(v)));
  d.lr("TOTAL", brl(c.total), true);
  if (c.paid > 0) d.lr("Pago", brl(c.paid)).lr("RESTANTE", brl(c.remaining), true);
  return d.center("Conferencia - documento sem valor fiscal").cut().out;
}

export function partialReceipt(p, t, pr) {
  const d = doc(pr).logo(t.settings?.ticket_logo !== false && t.settings?.logo_url).center(t.nome_fantasia).big("PAGAMENTO PARCIAL")
    .center(`Comanda ${p.number}${p.table_number ? ` - Mesa ${p.table_number}` : ""}`);
  if (p.customer_name) d.center(`Cliente: ${p.customer_name}`);
  d.center(fmtDateTime(p.at));
  if (p.label) d.center(p.label);
  d.hr();
  p.items.forEach((i) => d.lr(`${i.qty}x ${i.name}`, brl(i.total)));
  if (p.items.length) d.hr();
  d.lr("Total da conta", brl(p.total));
  if (p.paid_before > 0) d.lr("Ja pago antes", brl(p.paid_before));
  d.lr(PAY_LABELS[p.method] || p.method, brl(Math.max(p.received, p.amount)));
  if (p.change > 0) d.lr("Troco", brl(p.change));
  d.lr("VALOR PAGO", brl(p.amount), true).lr("RESTANTE NA COMANDA", brl(p.remaining), true).text(`Operador: ${p.user}`);
  return d.center("Documento sem valor fiscal").cut().out;
}

export function cashOpen(s, store, pr) {
  return doc(pr).center(store).big("ABERTURA DE CAIXA").hr().lr("Caixa", `${s.kind === "ticket" ? "Venda ticket" : "PDV"} #${s.number}`)
    .lr("Data/hora", fmtDateTime(s.opened_at)).lr("Aberto por", s.opened_by).text(`Usuarios: ${(s.user_names || []).join(", ")}`).hr()
    .lr("VALOR EM CAIXA (DINHEIRO)", brl(s.opening_amount), true).text("\n\n").center("______________________________").center("Assinatura do responsavel").cut().out;
}

export function cashClose(s, store, pr) {
  const sum = s.summary || {};
  const moves = s.movements || [];
  const d = doc(pr).center(store).big("FECHAMENTO DE CAIXA").hr().lr("Caixa", `${s.kind === "ticket" ? "Venda ticket" : "PDV"} #${s.number}`)
    .lr("Abertura", `${fmtDateTime(s.opened_at)} ${s.opened_by}`).lr("Fechamento", `${fmtDateTime(s.closed_at)} ${s.closed_by}`);
  if (s.user_names?.length) d.text(`Usuarios: ${s.user_names.join(", ")}`);
  d.hr().lr(`Vendas (${sum.sales_count || 0})`, brl(sum.sales_total)).hr().text("DINHEIRO EM CAIXA").lr("Valor inicial em dinheiro", brl(s.opening_amount))
    .lr("Vendas em dinheiro", `+ ${brl(sum.by_method?.dinheiro || 0)}`);
  ["suprimento", "sangria", "entrada", "saida"].forEach((k) => {
    const list = moves.filter((m) => m.type === k);
    if (!list.length && ["entrada", "saida"].includes(k)) return;
    const sign = ["sangria", "saida"].includes(k) ? "-" : "+";
    d.lr(`${CASH_MOVE_LABELS[k]} (${list.length})`, `${sign} ${brl(list.reduce((a, m) => a + m.amount, 0))}`);
    list.forEach((m) => d.lr(`  ${fmtDateTime(m.at)} ${m.note || ""}`, `${sign} ${brl(m.amount)}`));
  });
  d.lr("Dinheiro esperado", brl(sum.expected_cash), true).hr().text("POR FORMA DE PAGAMENTO");
  Object.entries(sum.by_method || {}).filter(([, v]) => v).forEach(([k, v]) => d.lr(PAY_LABELS[k] || k, brl(v)));
  d.hr().text("CONFERENCIA");
  Object.entries(s.differences || {}).forEach(([k, v]) => d.lr(`${PAY_LABELS[k] || k}: contado ${brl((s.counted || {})[k] ?? 0)}`, brl(v)));
  d.lr("DIFERENCA TOTAL", brl(s.total_difference ?? s.difference), true);
  if (s.close_notes) d.text(`Obs.: ${s.close_notes}`);
  return d.text("\n\n").center("______________________________").center("Assinatura do responsavel").cut().out;
}

export function courierDay(g, day, store, pr) {
  const d = doc(pr).center(store).big("ENTREGAS DO DIA").center(`${day.split("-").reverse().join("/")} - ${g.name}`).hr();
  g.orders.forEach((o) => d.lr(`#${o.number} ${o.customer}${o.status === "entrega" ? " (em rota)" : ""}`, `${brl(o.total)} ${o.paid_online ? "online" : PAY_LABELS[o.payment_method] || o.payment_method}`));
  d.hr().lr("Entregas", String(g.delivered)).lr("Em rota", String(g.on_route)).lr("Total entregue", brl(g.total), true).lr("Taxas de entrega", brl(g.fees)).hr().text("POR FORMA DE PAGAMENTO");
  Object.entries(g.by_payment).forEach(([k, v]) => d.lr(PAY_LABELS[k] || k, brl(v)));
  d.hr().lr("Dinheiro a prestar contas", brl(g.cash), true).lr("Troco levado", brl(g.change));
  if (g.rating_avg) d.lr(`Avaliacao media (${g.ratings})`, `${g.rating_avg} de 5`);
  return d.text("\n\n").center("______________________________").center("Assinatura do entregador").cut().out;
}

export function deliveryOrder(o, store, pr, reprint = false) {
  const type = { delivery: "Entrega", retirada: "Retirada", mesa: "Mesa", local: "No local", comanda: "Comanda" }[o.type] || o.type;
  const d = doc(pr);
  if (reprint) d.big("REIMPRESSAO").center(`2a via - ${fmtDateTime(new Date().toISOString())}`).hr();
  d.center(store).big(`PEDIDO #${o.number}`).center(type).center(fmtDateTime(o.created_at)).hr()
    .text(`Cliente: ${o.customer.name} ${o.customer.phone || ""}`);
  if (o.type === "delivery") d.text(`Endereco: ${o.customer.address}${o.zone ? ` (${o.zone})` : ""}`);
  if (o.type === "delivery" && o.pickup_code) d.center("CODIGO DE COLETA DO ENTREGADOR").big(o.pickup_code);
  if (o.table_number) d.text(`Mesa: ${o.table_number}`);
  if (o.comanda_number) d.text(`Comanda: ${o.comanda_number}`);
  d.hr();
  o.items.forEach((i) => { d.lr(`${i.qty}x ${i.name}`, brl(i.total)); if (i.notes) d.text(`   Obs: ${i.notes}`); });
  d.hr();
  if (o.delivery_fee > 0) d.lr("Entrega", brl(o.delivery_fee));
  if (o.payment_fee > 0) d.lr("Taxa da forma de pagamento", brl(o.payment_fee));
  if (o.coupon) d.lr(`Cupom ${o.coupon.code} (${o.coupon.label})`, `- ${brl(o.coupon.saved)}`);
  d.lr("TOTAL", brl(o.total), true).text(`Pagamento: ${PAY_LABELS[o.payment_method] || o.payment_method}${o.online?.status === "approved" ? " - PAGO ONLINE" : ""}`);
  if (o.change_for > 0) d.text(`Troco para ${brl(o.change_for)}`);
  if (o.notes) d.text(`Obs.: ${o.notes}`);
  return d.cut().out;
}
